'use strict';

angular.module('msLegacyActivities').controller('ActivityLongListCtrl', ['$log', '$scope', '$stateParams', '$state', 'activitySvc', function ($log, $scope, $stateParams, $state, activitySvc) {

  if ($stateParams.tag === 'search') {
    $state.go('activitySearchPage', {
      query: 'null'
    });
    return;
  }

  activitySvc.getActivitiesByTagWithMeta($stateParams.tag).then(function (resp) {
    $scope.activities = resp.activities;
    $scope.tag = resp.category;
  }, function (err) {
    $log.error(err);
  });
}]);